/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeepgramToken
 */
export interface DeepgramToken {
    /**
     * 
     * @type {string}
     * @memberof DeepgramToken
     */
    access_token: string;
    /**
     * 
     * @type {number}
     * @memberof DeepgramToken
     */
    expires_in: number;
}

/**
 * Check if a given object implements the DeepgramToken interface.
 */
export function instanceOfDeepgramToken(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "access_token" in value;
    isInstance = isInstance && "expires_in" in value;

    return isInstance;
}

export function DeepgramTokenFromJSON(json: any): DeepgramToken {
    return DeepgramTokenFromJSONTyped(json, false);
}

export function DeepgramTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeepgramToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'access_token': json['access_token'],
        'expires_in': json['expires_in'],
    };
}

export function DeepgramTokenToJSON(value?: DeepgramToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'access_token': value.access_token,
        'expires_in': value.expires_in,
    };
}

